import { render } from "./Section4.vue?vue&type=template&id=c8ed032e"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"
script.render = render

export default script